import axios from 'axios'

export default {
    mounted() {
        //console.log('[mixins]Global methods and variables was loaded!')
    },
    data() {
        return {
            AppName: 'Meteor Live',
            //CurPage: this
        }
    },
    computed: {
        BaseUrl() {
            if(process.env.NODE_ENV === 'development') {
                return 'http://mt.live.lan:9180/'
            } else {
                return '/'
            }
        }
    },
    methods: {
        valert(message, title, callback) {
            this.$emit('show_alert', message, title, callback, {showCancel:false, showOk:true});
        },
        vconfirm(message, title, callback) {
            this.$emit('show_alert', message, title, callback, {showCancel:true, showOk:true});
        },
        callApi(sender, ctl, act, args = {}, callback = null, error_callback = null) {
            if(sender) sender.$emit("show_overlay", true)
            var api_url = this.BaseUrl + 'mapi/?ctl=' + ctl + '&act=' + act
            var token = (localStorage.token? localStorage.token : 'mtxlive_20200531')
            var req_params = 'token=' + encodeURIComponent(token);
            for(var key in args) {
                req_params += '&' + key + '=' + encodeURIComponent(args[key]);
            }

            var vapp = this
            axios.post(api_url
                , req_params
                , {headers:{ 'Content-Type': 'application/x-www-form-urlencoded' }})
            .then(function (response) {
                console.log(response);  //DEBUG
                if(sender) sender.$emit("show_overlay", false)
                if(response.status == 200) {
                    var api_data = response.data;
                    if(api_data.status == 1) {
                        if(callback != null) callback(api_data);
                    } else {
                        var msg = (api_data.error? api_data.error : api_data.info);
                        vapp.valert(msg, 'エラー', function(){
                            if(callback != null) callback(api_data);
                        });
                    }
                } else {
                    vapp.valert(response.status + " " + response.statusText, 'エラー');
                }
            }).catch(function (error) {
                console.log(error);
                vapp.valert(error.message, 'エラー');
                if(error_callback) error_callback(error)
                if(sender) sender.$emit("show_overlay", false)
            });
        },
        isLogin() {
            var is_login = (localStorage.token != null && localStorage.token.length > 0)
            
            if(is_login) {
                this.callApi(this, 'login', 'is_login', {}, function(data){
                    if(data.status == 1) {
                        is_login = true
                        localStorage.user_id = data.user_id
                    } else {
                        localStorage.user_id = null
                        localStorage.token = null
                    }
                });
            }
            
            return is_login
        },
    }
}